<template>
  <div>
    <common-dialog
      ref="dialog"
      width="800px"
      show-save-button
      title="家长人脸"
      edit-title
      id-key="StudentId"
      :data="data"
      form-label-width="122px"
      :form-rules="rules"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      @closed="onClosed"
      :save-func="api.updateParentFace"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="开放家长人脸">
              <el-switch v-model="turnOn" :disabled="openDisabled" style="margin-top: -4px;"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="turnOn">
          <el-col :span="isMB?24:8">
            <photograph
              ref="photograph1"
              uploadUrl="/api/StudentInfo/UploadFace"
              v-model="data.ParentFace1PicUrl"
              :openDisabled="openDisabled"
              :form-data="{p:1}"
              @set-dis="setDis"
              @set-img="setImg('1')"
              @del-img="delImg('1')"
            >
              <div slot="title">
                <div>家长1
                  <span>{{data.ParentName1}}</span>
                  <span v-if="data.Alias1">({{data.Alias1}})</span>
                </div>
                <div style="margin-bottom: 5px;">
                  <span style="margin-right: 10px;">采集状态</span>
                  <template v-if="showStatus1">
                    <span v-if="data.ParentFace1Status==0">未采集</span>
                    <span v-if="data.ParentFace1Status==1">审核中</span>
                    <span v-if="data.ParentFace1Status==2">审核成功</span>
                    <span v-if="data.ParentFace1Status==3">审核失败</span>
                  </template>
                </div>
              </div>
            </photograph>
          </el-col>
          <el-col :span="isMB?24:8" :style="isMB?'margin:15px 0;':''">
            <photograph
              ref="photograph2"
              uploadUrl="/api/StudentInfo/UploadFace"
              v-model="data.ParentFace2PicUrl"
              :openDisabled="openDisabled"
              canvas-id="canvasCamera2"
              video-id="videoCamera2"
              :form-data="{p:2}"
              @set-dis="setDis"
              @set-img="setImg('2')"
              @del-img="delImg('2')"
            >
              <div slot="title">
                <div>家长2
                  <span>{{data.ParentName2}}</span>
                  <span v-if="data.Alias2">({{data.Alias2}})</span>
                </div>
                <div style="margin-bottom: 5px;">
                  <span style="margin-right: 10px;">采集状态</span>
                  <template v-if="showStatus2">
                    <span v-if="data.ParentFace2Status==0">未采集</span>
                    <span v-if="data.ParentFace2Status==1">审核中</span>
                    <span v-if="data.ParentFace2Status==2">审核成功</span>
                    <span v-if="data.ParentFace2Status==3">审核失败</span>
                  </template>
                </div>
              </div>
            </photograph>
          </el-col>
          <el-col :span="isMB?24:8">
            <photograph
              ref="photograph3"
              uploadUrl="/api/StudentInfo/UploadFace"
              v-model="data.ParentFace3PicUrl"
              :openDisabled="openDisabled"
              canvas-id="canvasCamera3"
              video-id="videoCamera3"
              :form-data="{p:3}"
              @set-dis="setDis"
              @set-img="setImg('3')"
              @del-img="delImg('3')"
            >
              <div slot="title">
                <div>家长3
                  <span>{{data.ParentName3}}</span>
                  <span v-if="data.Alias3">({{data.Alias3}})</span>
                </div>
                <div style="margin-bottom: 5px;">
                  <span style="margin-right: 10px;">采集状态</span>
                  <template v-if="showStatus3">
                    <span v-if="data.ParentFace3Status==0">未采集</span>
                    <span v-if="data.ParentFace3Status==1">审核中</span>
                    <span v-if="data.ParentFace3Status==2">审核成功</span>
                    <span v-if="data.ParentFace3Status==3">审核失败</span>
                  </template>
                </div>
              </div>
            </photograph>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import photograph from "@/components/common/photograph";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    photograph
  },
  data() {
    return {
      data: {
        StudentId: 0,
        ParentFace: 0,
        ParentFace1PicUrl: "",
        ParentFace1Status: 0,
        ParentFace2PicUrl: "",
        ParentFace2Status: 0,
        ParentFace3PicUrl: "",
        ParentFace3Status: 0,
        // TermId: null, //学期ID
        // TermName: "", //学期名称
        // StudentNumber: "", //学生编号
        // FullName: "", //姓名
        // IdCardNo: "", //身份证号
        ParentName1: "", //家长姓名1
        Alias1: "", //称呼1
        // ContactNumber1: "", //联系电话1
        // PublicId1: "", //公众号Id1
        ParentName2: "", //家长姓名2
        Alias2: "", //称呼2
        // Call2: "", //联系电话2
        // PublicId2: "", //公众号Id2
        ParentName3: "", //家长姓名3
        Alias3: "", //称呼3
        // ContactNumber3: "", //联系电话3
        // PublicId3: "", //公众号Id3
        // Sex: 0, //性别
        // Photo: "", //相片
        // FacePicUrl: "", //人脸地址
        // FaceId: "", //人脸Id
        // FaceStatus: 0, //人脸采集状态 无/采集处理中/采集成功/采集失败
        // VerCode: "",
        // CardNumber: "",
        // CurrentClassId: null,
        // CurrentClassName: null,
        // CurrentDormitory: null,
        // CurrentDormitoryId: null,
        // CurrentSeatNumber: null,
      },
      openDisabled: false,
      turnOn: false,
      showStatus1: true,
      showStatus2: true,
      showStatus3: true,
      api: require("@/api/st/student").default,
      isMB: this.$store.state.isMB,
      rules: {
        // Grade: [{ required: true, message: "请填写年级" }],
      },
    };
  },
  computed: {
    
  },
  methods: {
    onCreateOpened(data) {
    },
    onEditOpened(data) {
      this.turnOn = data.ParentFace == 1;
    },
    setImg(type) {
      this["showStatus" + type] = false;
    },
    delImg(type) {
      this.data["ParentFace" + type + "Status"] = 0;
      this["showStatus" + type] = true;
    },
    setDis(v) {
      this.openDisabled = v;
    },
    onBeforeSave() {
      this.data.ParentFace = this.turnOn?1:0;
      if(!this.data.ParentFace1PicUrl) this.data.ParentFace1Status = 0;
      if(!this.data.ParentFace2PicUrl) this.data.ParentFace2Status = 0;
      if(!this.data.ParentFace3PicUrl) this.data.ParentFace3Status = 0;
    },
    onClosed() {
      if(this.turnOn) {
        this.$refs.photograph1.clear();
        this.$refs.photograph2.clear();
        this.$refs.photograph3.clear();
        this.turnOn = false;
      }
      this.showStatus1 = true;
      this.showStatus2 = true;
      this.showStatus3 = true;
      this.openDisabled = false;
    },
  },
};
</script>
<style lang="scss" scoped>

</style>